import { format, isSameDay } from 'date-fns';
import type { ReactNode } from 'react';

/** Narrow shape for FullCalendar `dayHeader*` hooks (public types omit this export). */
export type CalendarDayHeaderArg = {
  date: Date;
  view: { type: string };
  text: string;
  isToday: boolean;
};

export type CalendarDayHeaderOptions = {
  selectedDate: Date;
  onWeekDayHeaderClick: (date: Date) => void;
};

export function getCalendarDayHeaderClassNames(arg: CalendarDayHeaderArg, selectedDate: Date): string {
  if (arg.view.type === 'dayGridMonth') {
    return 'sf-calendar-day-header--month';
  }
  if (arg.view.type === 'timeGridWeek') {
    if (isSameDay(arg.date, selectedDate)) return 'sf-calendar-day-header--selected-pill';
    if (arg.isToday) return 'sf-calendar-day-header--today';
    return '';
  }
  if (arg.view.type === 'timeGridDay') {
    return 'sf-calendar-day-header--selected-day';
  }
  return '';
}

export function renderCalendarDayHeaderContent(
  arg: CalendarDayHeaderArg,
  { selectedDate, onWeekDayHeaderClick }: CalendarDayHeaderOptions
): ReactNode {
  if (arg.view.type === 'dayGridMonth') {
    return <span className="sf-calendar-day-header__month-label">{arg.text}</span>;
  }

  const dow = format(arg.date, 'EEE');
  const dom = format(arg.date, 'd');

  if (arg.view.type === 'timeGridWeek') {
    const isSelected = isSameDay(arg.date, selectedDate);
    const isToday = arg.isToday;
    return (
      <button
        type="button"
        className="sf-calendar-day-header__btn"
        onClick={() => onWeekDayHeaderClick(arg.date)}
      >
        {isSelected ? (
          <div className="sf-calendar-day-header__pill sf-calendar-day-header__pill--week">
            <span className="sf-calendar-day-header__dow">{dow}</span>
            <span className="sf-calendar-day-header__dom">{dom}</span>
          </div>
        ) : (
          <div className="sf-calendar-day-header__stack">
            <span className="sf-calendar-day-header__dow">{dow}</span>
            <span className={`sf-calendar-day-header__dom ${isToday ? 'sf-calendar-day-header__dom--today' : ''}`}>
              {dom}
            </span>
          </div>
        )}
      </button>
    );
  }

  if (arg.view.type === 'timeGridDay') {
    return (
      <div className="sf-calendar-day-header__pill">
        <span className="sf-calendar-day-header__dow">{dow}</span>
        <span className="sf-calendar-day-header__dom">{dom}</span>
      </div>
    );
  }

  return (
    <div className="sf-calendar-day-header__stack">
      <span className="sf-calendar-day-header__dow">{dow}</span>
      <span className="sf-calendar-day-header__dom">{dom}</span>
    </div>
  );
}
